import Head from 'next/head'
import type {FC} from 'react'
import {BASE_URL} from '../utils'

type PaginationSEOProps = {
  currentPage: number
  totalPages: number
  baseUrl: string
  activeCategory?: string
}

/**
 * SEO component for pagination link tags
 * Adds canonical, prev, next links and robots meta for search engines
 */
export const PaginationSEO: FC<PaginationSEOProps> = ({currentPage, totalPages, baseUrl, activeCategory}) => {
  if (currentPage <= 0 || totalPages <= 0) {
    return null
  }

  const buildPageUrl = (pageNumber: number): string => {
    // Page 1 doesn't need the page number in the URL
    if (pageNumber === 1) {
      const path = activeCategory ? `${baseUrl}/category/${activeCategory}` : baseUrl
      return `${BASE_URL}${path}`
    }

    // Page 2+ includes the page number
    const path = activeCategory ? `${baseUrl}/category/${activeCategory}/${pageNumber}` : `${baseUrl}/${pageNumber}`
    return `${BASE_URL}${path}`
  }

  return (
    <Head>
      {/* Previous page link */}
      {currentPage > 1 && <link rel="prev" href={buildPageUrl(currentPage - 1)} />}
      {/* Next page link */}
      {currentPage < totalPages && <link rel="next" href={buildPageUrl(currentPage + 1)} />}
      {/* Only page 1 should be indexed, others should follow links but not be indexed */}
      {currentPage > 1 && <meta name="robots" content="index, follow" />}
    </Head>
  )
}
